import {
  SET_NOTICIAS,
  SET_LABORATORIOS,
  SET_OPCIONES_MENU,
  SET_BANNERS,
  SET_SERVICIOS,
  SET_SEDES,
  SET_QUIENES_SOMOS,
  SET_QUIENES_SOMOS_BTN,
  SET_POLITICAS,
  SET_MODELO_ATENCION,
  SET_CONTACTO,
} from './ApiActions';

const ApiReducer = (state, action) => {
  switch (action.type) {
    case SET_NOTICIAS:
      return {
        ...state,
        noticias: { ...state.noticias, ...action.payload },
      };

    case SET_LABORATORIOS:
      return {
        ...state,
        laboratorios: { ...state.laboratorios, ...action.payload },
      };

    case SET_OPCIONES_MENU:
      return {
        ...state,
        opcionesMenu: { ...state.opcionesMenu, ...action.payload },
      };

    case SET_BANNERS:
      return {
        ...state,
        banners: { ...state.banners, ...action.payload },
      };

    case SET_SERVICIOS:
      return {
        ...state,
        servicios: { ...state.servicios, ...action.payload },
      };

    case SET_SEDES:
      return {
        ...state,
        sedes: { ...state.sedes, ...action.payload },
      };

    case SET_QUIENES_SOMOS:
      return {
        ...state,
        quienesSomos: { ...state.quienesSomos, ...action.payload },
      };

    case SET_QUIENES_SOMOS_BTN:
      return {
        ...state,
        quienesSomosBtn: { ...state.quienesSomosBtn, ...action.payload },
      };

    case SET_POLITICAS:
      return {
        ...state,
        politicas: { ...state.politicas, ...action.payload },
      };

    case SET_MODELO_ATENCION:
      return {
        ...state,
        modeloAtencion: { ...state.modeloAtencion, ...action.payload },
      };

    case SET_CONTACTO:
      return {
        ...state,
        contacto: { ...state.contacto, ...action.payload },
      };

    default:
      return state;
  }
};

export default ApiReducer;
